import {
  ResizeObserver as Polyfill,
  ResizeObserverEntry,
} from '@juggle/resize-observer';
import { RefObject, useCallback, useState } from 'react';

import { useEnhancedEffect } from 'hooks/useEnhancedEffect';

const ResizeObserverClass =
  typeof ResizeObserver === 'undefined' ? Polyfill : ResizeObserver;

export const useResizeObserver = (ref: RefObject<HTMLElement>) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const handleResize = useCallback((entries: Array<ResizeObserverEntry>) => {
    if (!Array.isArray(entries)) {
      return;
    }
    const entry = entries[0];
    setWidth(entry.contentRect.width);
    setHeight(entry.contentRect.height);
  }, []);

  useEnhancedEffect(() => {
    if (!ref.current) {
      return;
    }

    const myObserver = new ResizeObserverClass(
      (entries: Array<ResizeObserverEntry>) => {
        handleResize(entries);
      },
    );
    myObserver.observe(ref.current);

    return () => {
      myObserver.disconnect();
    };
  }, [handleResize, ref]);

  return [width, height];
};
